import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function ErrorView() {
  const navigate = useNavigate();
  const { t } = useTranslation('errorPage');

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 bg-synergy-bg-secondary-dark">
      <h1 className="text-2xl font-bold text-synergy-text-primary">
        {t('title')}
      </h1>
      <p className="whitespace-pre-line text-center text-synergy-text-secondary">
        {t('description')}
      </p>
      <Button onClick={() => navigate('/home')}>{t('home')}</Button>
    </div>
  );
}
